import styled from 'styled-components'
import { FaBars } from 'react-icons/fa'
import { GiCancel } from 'react-icons/gi'
import { Col, Row } from 'antd';
import { Logo } from '../Icons/Logo';


export const LogoHeader = styled(Logo)`
    width: 100%;
    height: 100%;

    @media screen and (max-width: 768px) {
        float: right;
        width: 80px;
        height: 35px;
    }   
`


export const HeaderLink = styled.a`
  color: #fff;
  margin-bottom: 20px;
  font-size: 15px;
  text-decoration: none;
  margin: 0 2px;

  &:hover {
      color: #F9BE84;
      transition: 200ms ease-in;
  }
`;

export const RowHeader = styled(Row)`
    padding: 2%;
    background: #fff;

    @media screen and (max-width: 768px) {
        padding: 3% 0px;
    }    
`

export const ColOptions = styled(Col)`
    margin: auto;
    text-align: center;

    @media screen and (max-width: 768px) {
        margin: unset;
        text-align: unset;
        padding-left: 5%;
    }
`

export const ColSocialNetworks = styled(Col)`
    margin: auto;
    text-align: center;

    @media screen and (max-width: 768px) {
        margin: unset;
    }
`

export const ColLogo = styled(Col)`
    margin: auto;

    @media screen and (max-width: 768px) {
        margin: unset;
        height: 6vh;
        padding-right: 3%;
    }
`

export const Cancel = styled(GiCancel)`
display: none;
color: #C24728;

@media screen and (max-width: 768px) {
    display: inline-block;
    position: relative;
    font-size: 1.5rem;
    cursor: pointer;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 1000;
    height: 100%;

    &:focus {
        outline: none;
    }
}
`

export const Bars = styled(FaBars)`
    display: none;
    color: #C24728;

    @media screen and (max-width: 768px) {
        display: inline-block;
        position: relative;
        font-size: 1.5rem;
        cursor: pointer;
        background: transparent;
        border: none;
        cursor: pointer;
        z-index: 1000;
        height: 100%;

        &:focus {
            outline: none;
        }
    }
`
